import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

export default ({ children }) => {

    /* Portalled to body: overlays are rendered from inside containers that
       create stacking contexts (e.g. the sticky admin sidebar), which would
       otherwise trap the fixed overlay beneath the page content. */
    return ReactDOM.createPortal(
        <div className="initial-setup-overlay-container">
            {children}
        </div>,
        document.body
    );

}
